import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AppSettings} from '../../config/config';
import {map} from 'rxjs/operators';

@Injectable()
export class InsightsService {

  private URL_V3 = AppSettings.API_ENDPOINT_V3;

  constructor(private http: HttpClient) {
  }

  // Fetch all insights data using GET method with V3 API
  fetchInsightsData(academicId: any, lang: string, AUTHTOKEN: any) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('token', AUTHTOKEN);
    const params = new HttpParams()
      .set('academicId', academicId.toString())
      .set('lang', lang || 'en');
    return this.http.get(this.URL_V3 + '/ai/insights', {headers, params}).pipe(map(res => res));
  }
}


